export const DEEP_LINKS_STATE_TOKEN = 'DEEP_LINKS';

export const DEEP_LINKS_API_PATHS = {
};
